import React, {useEffect, useMemo, useRef, useState} from 'react';
import {Dialog} from "primereact/dialog";
import {Button} from "primereact/button";
import {useTranslate} from "../../../system/useTranslate";
import Icon from "../../../system/components/icon";
import BoxHeader from "../../components/box-header";
import Span from "../../../system/components/span";
import {InputText} from "primereact/inputtext";
import {MultiSelect} from "primereact/multiselect";
import {useSelector} from "react-redux";
import Avatar from "../../../system/components/avatar";
import {InputTextarea} from "primereact/inputtextarea";
import {Sidebar} from "primereact/sidebar";
import UploadDialog from "../../components/upload-dialog";
import {Messages} from "primereact/messages";
import DataFieldItem from "../../../system/components/data-field-item";
import {Dropdown} from "primereact/dropdown";
import {isPast, removeDuplicateObjects, severity, timeSince} from "../../../system/utils";
import TaskTypeDialog from "../../components/task-type-dialog";
import SelectMember from "../../tasks/components/select-member";
import MultiSelectProjects from "../../tasks/components/multi-select-projects";
import {isEmptyArray} from "formik";
import SelectZofinoDateTime from "../../tasks/components/select-zofino-datetime";
import Attachments from "../../tasks/components/attachments";
import AvatarGroup from "../../../system/components/avatar-group";
import {useTask} from "../../../models/task/use-task";
import {DataView} from "primereact/dataview";
import AccordionDataView from "../../tasks/components/accordion-dataview";
import TaskSidebar from "./task-sidebar";
import {Checkbox} from "primereact/checkbox";
import SelectTasksDialog from "../../tasks/components/select-tasks-dialog";
import SelectProject from "../../tasks/components/select-project";
import {Menu} from "primereact/menu";
import {useDeliverableComment} from "../../../models/deliverable-comment/use-deliverable-comment";
import {MeterGroup} from "primereact/metergroup";
import TaskFocusControls from "../../../system/focus/task-focus-controls";
import TaskDialog from "../../tasks/task-dialog";
import EditableComment from "../../components/editable-comment";
import ChatComposer, {mentionToken} from "../../inbox/chat-composer";
import {MessageContent} from "../../inbox/chat-message";
import ChatMessageAttachment from "../../inbox/chat-message-attachment";
import {chatMessageAttachmentIdentifiers} from "../../inbox/chat-message-attachment-payload";
import {usePermission} from "../../../system/usePermission";
import {RichTextField} from "../../../system/components/rich-text";

function DeliverableSidebar({onSubmit, selectedDeliverable, setSelectedDeliverable, tasks, updateTask, disabled, createTask}) {
    // console.log(selectedDeliverable)
    const translate = useTranslate();
    const messages = useRef();
    const {workspaceMembershipData} = useSelector((state) => state.app);
    const [uploadDialogVisible, setUploadDialogVisible] = useState(false);
    const task = useTask();
    const safeTasks = Array.isArray(tasks) ? tasks : [];
    const deliverableTasks = task.filterByDeliverable(safeTasks, selectedDeliverable);
    // const [tasks, setTasks] = useState([]);
    const [selectedStatus, setSelectedStatus] = useState();
    const [selectedTask, setSelectedTask] = useState();
    const [selectTasksDialogVisible, setSelectTasksDialogVisible] = useState(false);
    const [createTaskDialogVisible, setCreateTaskDialogVisible] = useState(false);
    const { user } = useSelector(state => state.auth);
    const moreMenu = useRef();

    const moreMenuItems = [
        {
            label: translate("delete"),
            command: async () => {
                await onSubmit({
                    archivedAt: new Date(),
                    archivedBy: workspaceMembershipData,
                });

                setSelectedDeliverable(undefined);
            },
        },
    ];
    useEffect(() => {
        setSelectedStatus(undefined)
    }, [selectedDeliverable]);

    useEffect(() => {
        if (!selectedDeliverable) return undefined;
        const closeUnlessMilestoneSelected = (event) => {
            const target = event.target;
            if (!(target instanceof Element)) return;
            if (target.closest(".p-sidebar")) return;
            if (target.closest(".deliverable-sidebar-trigger")) return;
            if (target.closest("[data-zofino-floating-layer]")) return;
            if (target.closest(".p-dialog, .p-overlaypanel, .p-dropdown-panel, .p-multiselect-panel, .p-datepicker, .p-menu, .p-tooltip")) return;
            setSelectedDeliverable(undefined);
        };
        document.addEventListener("mousedown", closeUnlessMilestoneSelected);
        return () => document.removeEventListener("mousedown", closeUnlessMilestoneSelected);
    }, [selectedDeliverable, setSelectedDeliverable]);


    // useEffect(() => {
    //     console.log(selectedStatus)
    // }, [selectedStatus]);

    // const findTasks = async ()=>{
    //     let query = {
    //         filters: {
    //             $and: [
    //                 { workspace: { $eq: workspaceMembershipData?.workspace.id } },
    //                 { deliverable: { $eq: selectedDeliverable?.id } },
    //             ],
    //         },
    //         sort: ["dueDate:asc"],
    //         populate: {
    //             assignee: { populate: ["profileImage"] },
    //         }
    //     };
    //
    //     let _data = await task.findTasks(query);
    //
    //     setTasks(_data)
    // }

    const Header = ({disabled})=>{

        return(
            <div className="p-3 flex align-items-center justify-content-between border-bottom-1 border-300 w-full h-4rem">

                <div className="flex align-items-center">
                    <Button disabled={disabled} onClick={()=>{onSubmit({deliverableStatus:selectedDeliverable?.deliverableStatus==="todo"?"done":"todo"})}} className="flex-row-reverse p-button-secondary p-button-outlined p-2 pr-2 pl-2 text-xs border-round-xl flex align-items-center gap-2" label={translate(selectedDeliverable?.deliverableStatus==="done"?"deliverable-done":"set-deliverable-done")}>
                        <Icon icon={`${selectedDeliverable?.deliverableStatus==="done"?"mi mi:check_circle":"mi mi:radio_button_unchecked"}`}/>
                    </Button>
                </div>
                <div className={`flex align-items-center gap-4 `}>
                    <div className={`flex align-items-center gap-4 ${disabled && " p-disabled"} ${selectedDeliverable?.deliverableStatus==="done"&&"p-disabled"}`}>
                        <Icon icon="mi mi:link" onClick={()=>{}}/>
                        <Icon icon="mi mi:attach_file"  onClick={()=>{setUploadDialogVisible(true)}}/>
                        <Icon icon="mi mi:more_horiz"  onClick={(e)=>{moreMenu.current.toggle(e)}}/>
                        <Menu popup ref={moreMenu} model={moreMenuItems}
                              pt={{
                                  root: () =>({className:"w-fit p-1"}),
                                  menuitem: () =>({className:"text-sm rtl"})
                        }}
                            />
                        <span className="h-1rem border-right-2 border-300"/>
                    </div>
                    <Icon icon="mi mi:close_small" className="text-3xl" onClick={()=>{setSelectedDeliverable(undefined)}}/>
                </div>

                <UploadDialog entityType="deliverable" entityDocumentId={selectedDeliverable?.documentId} visible={uploadDialogVisible} setVisible={setUploadDialogVisible} updateContentType={(e)=>{onSubmit({attachments: {connect:e.map(e=>({id:e.id}))}})}}/>
            </div>
        )
    }

    return (
        <Sidebar dir="rtl"  header={<Header  disabled={disabled}/>} showCloseIcon={false} dismissable={false} modal={false} visible={selectedDeliverable!==undefined}  className={`w-5`} onHide={()=>{setSelectedDeliverable(undefined)}} pt={{header: () => ({style: {padding: 0, margin: 0}}), content: () => ({style: {padding: 0}})}}>
            {selectedStatus?(
                <div className={`flex flex-column`}>
                    <div className={`flex align-items-center justify-content-between p-2  `}>
                        <span>{translate(selectedStatus?.label)}</span>
                        <Button onClick={()=>{setSelectedStatus(undefined)}} className="border-none shadow-none p-1 px-2 p-button-text p-button-danger text-xs flex flex-row-reverse" icon={<Icon icon="mi mi:chevron_backward"/>} label={translate("back-to-milestone")}/>
                    </div>
                    <div className={`text-xs `}>
                        <AccordionDataView tabs={[{title:translate(selectedStatus?.label), value: safeTasks.filter(t => selectedStatus?.value?.some(s => s.id === t.id)), className:"text-red-500"},]} activeIndex={[0,1,2]} columns={[
                            {header: "", headerClassName: "w-4rem", cellClassName: "w-4rem", render: (row) => <Checkbox checked={row.taskStatus==="done"} onChange={(e)=>{updateTask(row, {doneAt:Date.now(), taskStatus:row?.taskStatus==="todo"?"done":"todo"})}}/> },
                            {header: translate("task-title"), headerClassName: "flex-1", cellClassName: "flex-1", render: (row) => <span data-task-sidebar-trigger="true" className="inline-flex align-items-center gap-2 w-full h-full" dir="ltr"><span dir="rtl">{row.title}</span><TaskFocusControls task={row} compact/></span>, onCellClick:(e)=>{setSelectedTask(e)} },
                            {header: translate("assignee"), headerClassName: "w-7rem", cellClassName: "w-7rem", render: (row) => <Avatar memberData={row.assignee?.member} /> },
                            {header: translate("dueDate"), headerClassName: "w-7rem", cellClassNameDynamic: (row) => `w-7rem text-xs ${isPast(new Date(row.dueDate).getTime()/1000,1,"days") ? "text-red-500" : ""}`, render: (row) => row.dueDate ? timeSince(new Date(row.dueDate).getTime()/1000) : null },
                            {header: translate("projects"), headerClassName: "w-7rem", cellClassName: "w-7rem", render: (row) =><div className="w-7rem flex flex-wrap gap-1">{row.projects?.map(p=>(<span className="border-round px-1 border-1 border-200 surface-100 text-2xs">{p.title}</span>))}</div>},
                        ]} />
                    </div>
                    <TaskSidebar disabled={disabled} setSelectedTask={setSelectedTask} selectedTask={safeTasks.find(task=>task.id===selectedTask?.id)} updateTask={updateTask}/>
                </div>
            ):(
                <div className="flex-1 min-h-0 flex flex-column align-items-center w-full overflow-auto scrollbar-hide p-3">
                        <div className={`w-full flex flex-column align-items-center ${disabled || selectedDeliverable?.deliverableStatus === "done" ? "p-disabled" : ""}`}>
                        <Messages className="w-full" ref={messages}/>
                        {/*<Message title={translate("private-task")} icon={<Icon icon="mi mi:lock"/>} left={<Button className="text-xs p-button-danger p-button-text p-1 pl-3 pr-3 border-none shadow-none" label={translate("set-public")}/>}/>*/}
                        <div className="w-full rtl pt-3">
                            {/*<Span spanClassName="text-2xl font-bold">{}</Span>*/}
                            <DataFieldItem className="text-2xl font-bold w-full pt-2 pb-2" value={selectedDeliverable?.title} onKeyDownEnter={(e)=>{onSubmit({title:e.value})}}/>
                        </div>
                        <div className="flex flex-column w-full mt-4 gap-1">
                            <LabelValue label={translate("assignee")} value={<SelectMember selectedMember={selectedDeliverable?.assignee} members={workspaceMembershipData?.workspace.workspace_memberships || []} onChange={(membership)=>{onSubmit({assignee: membership})}}/>}/>
                            <LabelValue label={translate("involved-members")} value={<InvolvedMembers members={deliverableTasks.map(t=>t.assignee)}/>}/>
                            <LabelValue label={translate("dueDate")} value={<SelectZofinoDateTime range selectedDateTime={{end:selectedDeliverable?.doneAt?new Date(selectedDeliverable?.doneAt).getTime()/1000:null,start:selectedDeliverable?.startAt?new Date(selectedDeliverable?.startAt).getTime()/1000:null}} onChange={(e)=>{onSubmit({doneAt:e.end?new Date(e.end?.toUnix()*1000):null, startAt:e.start?new Date(e.start?.toUnix()*1000):null})}}/>} />
                            <LabelValue label={translate("project")} value={<SelectProject onChange={(e)=>{onSubmit({project:e?.id})}} readOnly projects={workspaceMembershipData?.workspace?.projects} selectedProject={selectedDeliverable?.project}/>}/>
                            {/*<LabelValue label={translate("project")} value={<MultiSelectProjects nullable={false} selectedProjects={isEmptyArray(selectedDeliverable?.projects)?null:selectedDeliverable?.projects} projects={workspaceMembershipData?.workspace.projects} onChange={(e)=>{onSubmit({projects: e??null})}}/>}/>*/}
                            <LabelValue label={translate("permit")} value={<div className="w-full"><DataFieldItem longText placeholder={translate("task.assignee-authority.placeholder")} className="text-xs w-full py-2" value={selectedDeliverable?.assigneeAuthority ?? ""} onKeyDownEnter={(e)=>{onSubmit({assigneeAuthority:String(e.value ?? "").trim()})}}/></div>}/>
                            <LabelValue label={translate("result")} value={<div className="w-full"><DataFieldItem longText placeholder={translate("task.expected-result.placeholder")} className="text-xs w-full py-2" value={selectedDeliverable?.expectedResult ?? ""} onKeyDownEnter={(e)=>{onSubmit({expectedResult:String(e.value ?? "").trim()})}}/></div>}/>

                            <MilestoneTaskProgress tasks={deliverableTasks}/>

                            <Attachments attachments={selectedDeliverable?.attachments} onAddClicked={()=>{setUploadDialogVisible(true)}}/>
                            <TasksStatus tasks={deliverableTasks} onSelect={(e)=>{setSelectedStatus(e)}}/>

                            <div className="flex w-full gap-2">
                                <Button onClick={()=>{setSelectTasksDialogVisible(true)}} className="text-sm flex-1 border-round-2xl" label={translate("add-tasks-to-deliverable")} icon={<Icon icon="mi mi:add_task"/>} />
                                {createTask&&(
                                    <Button onClick={()=>{setCreateTaskDialogVisible(true)}} className="text-sm flex-1 border-round-2xl p-button-outlined" label={translate("deliverable-create-task")} icon={<Icon icon="mi mi:add"/>} />
                                )}
                            </div>
                            <SelectTasksDialog milestoneTitle={selectedDeliverable?.title} projectTasks={task.filterByDeliverable(safeTasks, selectedDeliverable, true)} deliverableTasks={deliverableTasks} visible={selectTasksDialogVisible} setVisible={setSelectTasksDialogVisible} onHide={() => setSelectTasksDialogVisible(false)} onChange={(e)=>{onSubmit({tasks:e.length>0?e.map(e=>e.id):null})}}/>
                            {createTask&&(
                                <TaskDialog
                                    visible={createTaskDialogVisible}
                                    setVisible={setCreateTaskDialogVisible}
                                    payload={{taskData: {projects: (workspaceMembershipData?.workspace?.projects||[]).filter(project => project.id === selectedDeliverable?.project?.id)}}}
                                    onSubmit={async (normalizedTask, subTasks) => {
                                        await createTask({
                                            ...normalizedTask,
                                            deliverables: {connect: selectedDeliverable?.id ? [{id: selectedDeliverable.id}] : []},
                                        });
                                        setCreateTaskDialogVisible(false);
                                    }}
                                />
                            )}
                            <LabelValue label={translate("deliverable-description")} value={<div className="w-full text-xs pt-2 pb-2"><RichTextField value={selectedDeliverable?.description} disabled={disabled} placeholder={translate("deliverable-description")} onSave={(html)=>onSubmit({description: html})}/></div>}/>

                        </div>
                        </div>
                    <div className="w-full">
                        <Comments deliverableData={selectedDeliverable} canManageOthers={!disabled}/>
                    </div>
                </div>
            )}
        </Sidebar>
    );
}


function MilestoneTaskProgress({tasks}) {
    const translate = useTranslate();
    const task = useTask();
    const milestoneTasks = Array.isArray(tasks) ? tasks : [];
    const totalTasks = milestoneTasks.length;
    const doneTasks = milestoneTasks.filter(item => item?.taskStatus === "done").length;
    const behindTasks = task.filter(milestoneTasks, "overdue").length;
    const donePercent = totalTasks > 0 ? (doneTasks / totalTasks) * 100 : 0;
    const behindPercent = totalTasks > 0 ? (behindTasks / totalTasks) * 100 : 0;
    const values = [
        {label: translate("done"), value: donePercent, count: doneTasks, color: "#0CC0CC"},
        {label: translate("overdue"), value: behindPercent, count: behindTasks, color: "#E6511C"}
    ];

    return (
        <div className="w-full surface-30 border-1 border-200 border-round-xl p-3 my-2">
            <div className="text-xs font-bold mb-3">{translate("tasks-status")}</div>
            <MeterGroup values={values} max={100} labelList={() => null}
                        pt={{
                            metercontainer: () => ({className: "border-round-xl overflow-hidden", style: {height: "0.6rem", backgroundColor: "#E5E7EB"}}),
                            meter: () => ({style: {height: "0.6rem"}})
                        }}/>
            <div className="flex align-items-center justify-content-start gap-3 mt-3">
                {values.map(item => (
                    <div key={item.label} className="flex align-items-center gap-2 text-xs">
                        <span className="border-circle flex-shrink-0" style={{width: "0.65rem", height: "0.65rem", backgroundColor: item.color}}/>
                        <span className="text-600">{item.label}</span>
                        <span className="font-bold">{item.count}</span>
                    </div>
                ))}
            </div>
        </div>
    )
}

function InvolvedMembers({members}) {
    return(
        <AvatarGroup>{removeDuplicateObjects(members.filter(m=>m!==null), "documentId").map(m=><Avatar className="text-3xs" style={{width:"1.55rem", height:"1.55rem"}} memberData={m?.member}/>)}</AvatarGroup>
    )
}

function TasksStatus({tasks, onSelect}) {
    const translate = useTranslate();
    const task = useTask();

    const status = {
        all:{label:"all-tasks", value:task.filter(tasks), severity:"info"},
        overdue:{label:"overdue", value:task.filter(tasks,"overdue"), severity:"error"},
        near:{label:"near", value:task.filter(tasks,"near"), severity:"warning"}
    }

    const Status = ({data, onClick})=>{
        return(
            <div className="w-4">
                <div onClick={()=>{onClick?.(data)}} className={`w-full h-6rem border-1 border-round-2xl text-sm ${onClick&&"cursor-pointer"} ${severity("border", data?.severity)} ${severity("text", data?.severity)} flex flex-column align-items-center justify-content-center font-bold`}>
                    <span>{data?.value?.length||0}</span>
                    <span>{translate(data?.label)}</span>
                </div>
            </div>
        )
    }

    return(
        <div className="flex gap-2 py-2">
            <Status data={status.all} label={status.label} onClick={(e)=>{onSelect?.(e)}}/>
            <Status data={status.overdue} label={status.label} onClick={(e)=>{onSelect?.(e)}}/>
            <Status data={status.near} label={status.label} onClick={(e)=>{onSelect?.(e)}}/>
        </div>
    )
}

function Message({title, icon, left}) {
    return(
        <div className="w-full flex align-items-center justify-content-between border-round-2xl surface-100 p-3 text-xs">
            <div className="flex align-items-center gap-2">
                {icon}
                <span>{title}</span>
            </div>
            {left??<span/>}

        </div>
    )
}
//
function LabelValue({label, value}) {
    return(
        <div className="w-full grid align-items-start p-2 m-0" dir="rtl">
                <span className="col-fixed text-xs text-400 text-right pt-2 px-0" style={{width:"7rem"}}>{label}</span>
            <div className="col min-w-0 p-0 flex align-items-center justify-content-start min-h-3rem text-right" dir="rtl">
                {value??<></>}
            </div>
        </div>
    )
}

function Footer() {
    const {user} = useSelector(state => state.auth);
    const translate = useTranslate();
    return(
        <div className="w-full border-top-1 border-200 flex p-2 gap-2">
            <Avatar memberData={user}/>
            <div className="flex-1 border-1 border-round-3xl border-300 p-2">
                <InputTextarea  placeholder={translate("your-comment-placeholder")} className="w-full border-none shadow-none p-1 text-sm" rows={3}/>
                <div className="flex justify-content-between align-items-center">
                    <div className="flex align-items-center gap-3 text-500">
                        <Icon icon="mi mi:alternate_email" onClick={()=>{}}/>
                        <Icon icon="mi mi:format_bold" onClick={()=>{}}/>
                        <Icon icon="mi mi:sentiment_satisfied" onClick={()=>{}}/>
                        <Icon icon="mi mi:attach_file" onClick={()=>{}}/>
                    </div>
                    <Button className="p-2 pl-3 pr-3 text-xs font-light border-round-2xl" label={translate("send")}/>
                </div>
            </div>

        </div>
    )
}

function Comments({deliverableData, canManageOthers}) {
    const translate = useTranslate();
    const {workspaceMembershipData, workspaceId} = useSelector((state) => state.app);
    const [comments, setComments] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const deliverableComment = useDeliverableComment();
    const activeWorkspaceId = workspaceMembershipData?.workspace?.documentId || workspaceId;
    const members = useMemo(() => (
        (workspaceMembershipData?.workspace?.workspace_memberships || [])
            .map((membership) => membership?.member)
            .filter((member) => member?.id)
    ), [workspaceMembershipData]);

    const ItemTemplate = (data) => {
        return (
            <EditableComment
                comment={data}
                canManageOthers={canManageOthers}
                onError={setError}
                onUpdate={async (comment, text) => {
                    const updated = await deliverableComment.updateDeliverableComment(comment.documentId || comment.id, {text});
                    setComments((current) => current.map((item) => (
                        (item.documentId || item.id) === (comment.documentId || comment.id) ? updated : item
                    )));
                }}
                onDelete={async (comment) => {
                    await deliverableComment.deleteDeliverableComment(comment.documentId || comment.id);
                    setComments((current) => current.filter((item) => (
                        (item.documentId || item.id) !== (comment.documentId || comment.id)
                    )));
                }}
            >
                <div className="p-2 w-full border-round surface-50 flex flex-column gap-2">
                    {data.text && <MessageContent content={data.text} mentions={data.mentions}/>}
                    {(data.attachments || []).map((file) => (
                        <ChatMessageAttachment key={file?.documentId || file?.id} file={file} workspaceId={activeWorkspaceId} onError={() => setError(translate("task-comment.error.attachment-access"))}/>
                    ))}
                    {!data.text && !(data.attachments || []).length && <span className="text-xs text-400">{translate("task-comment.empty-content")}</span>}
                </div>
            </EditableComment>
        );
    };

    useEffect(() => {
        if (!deliverableData?.id) {
            setComments([]);
            return;
        }
        getDeliverableComments();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [deliverableData]);

    const getDeliverableComments = async () => {
        try {
            setError("");
            setLoading(true);
            const _data = await deliverableComment.getDeliverableComments(deliverableData.id);
            setComments(_data || []);
        } catch (e) {
            setError(translate("entity-comment.error.load"));
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="p-3 flex flex-column w-full gap-3 overflow-visible">
            <div className="w-full flex-shrink-0">
                <CreateDeliverableComment deliverableData={deliverableData} members={members} onSubmit={(comment) => setComments((current) => [...current, comment])} onError={setError}/>
            </div>
            {error && <span role="alert" className="text-xs text-red-500 px-2">{error}</span>}
            {loading ? <div className="flex align-items-center justify-content-center p-3"><Icon icon="mi mi:progress_activity" className="pi-spin text-primary text-xl"/></div> : <DataView emptyMessage={<></>} itemTemplate={ItemTemplate} layout="list" value={comments}/>} 
        </div>
    );
}

function CreateDeliverableComment({deliverableData, members, onSubmit, onError}) {
    const translate = useTranslate();
    const [text, setText] = useState("");
    const [mentions, setMentions] = useState([]);
    const [attachments, setAttachments] = useState([]);
    const [uploadVisible, setUploadVisible] = useState(false);
    const [sending, setSending] = useState(false);
    const deliverableComment = useDeliverableComment();
    const permission = usePermission();
    const canAttach = permission.can("upload-file");

    useEffect(() => {
        setText("");
        setMentions([]);
        setAttachments([]);
        setUploadVisible(false);
    }, [deliverableData?.id]);

    const createComment = async () => {
        if (sending || !deliverableData?.id || (!text.trim() && !attachments.length)) return;
        setSending(true);
        onError?.("");
        try {
            const comment = await deliverableComment.createDeliverableComment({deliverable: deliverableData.id, text: text.trim() || null, mentions: mentions.map((mention) => ({id: mention.id, token: mention.token})), attachments: chatMessageAttachmentIdentifiers(attachments)});
            if (!comment) throw new Error("task-comment.error.create");
            onSubmit?.(comment);
            setText("");
            setMentions([]);
            setAttachments([]);
        } catch (error) {
            onError?.(translate("task-comment.error.create"));
        } finally {
            setSending(false);
        }
    };

    const handleChange = (event) => {
        const value = event.target.value;
        setText(value);
        setMentions((current) => current.filter((mention) => value.includes(`@${mention.token || mentionToken(mention)}`)));
    };

    const handleSelect = ({suggestion}) => {
        if (suggestion?.suggestionType !== "mention") return;
        const mention = {id:suggestion.id, documentId:suggestion.documentId, fullname:suggestion.fullname, username:suggestion.username, token:suggestion.insertText};
        setMentions((current) => current.some((item) => String(item.id) === String(mention.id)) ? current : [...current, mention]);
    };

    const removeAttachment = (attachment) => {
        const key = attachment?.documentId ?? attachment?.id;
        setAttachments((current) => current.filter((item) => String(item?.documentId ?? item?.id) !== String(key)));
    };

    return (
        <>
            <ChatComposer value={text} members={members} references={[]} attachments={attachments} onChange={handleChange} onSelect={handleSelect} onRemoveAttachment={removeAttachment} canAttach={canAttach} onAttach={() => setUploadVisible(true)} onSubmit={createComment} submitDisabled={!text.trim() && !attachments.length} loading={sending} disabled={sending} placeholder={translate("task-comment.composer.placeholder")} quickActionTypes={["mention"]} triggers={["@"]}/>
            <UploadDialog visible={uploadVisible} setVisible={setUploadVisible} multiple entityType="deliverable" entityDocumentId={deliverableData?.documentId || deliverableData?.id} purpose="attachment" updateContentType={(files) => setAttachments((current) => { const existing = new Set(current.map((item) => String(item?.documentId ?? item?.id))); return [...current, ...files.filter((item) => !existing.has(String(item?.documentId ?? item?.id)))]; })}/>
        </>
    );
}

export default DeliverableSidebar;
